import * as React from "react";

import { CustomerListModel } from "../../customer";

import { CreateEditEmployee } from "./CreateEditEmployee";

// Component is intentionally left bare-bones like this to allow for any future customisation
export const CreateEmployeeForm = ({ customer }: { customer: CustomerListModel }) => {
    return (
        <CreateEditEmployee customer={customer} />
    );
};
